// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/pages/ExploreTour.jsx

import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from '../components/Header';
import Tourview from '../components/Content/Tourview';
import TourForm from '../components/Content/TourForm';
import { ProgressSpinner } from 'primereact/progressspinner';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import '../css/Member.css';
import { fetchContentTour, insertContentTour, updateContentTour, deleteContentTour } from '../utils/ExploreTourHandlers';
import { useNavigate } from 'react-router-dom';

const ExploreBlog = () => {
  const [ideas, setIdeas] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [pageLength, setPageLength] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showForm, setShowForm] = useState(false);
  const [formMode, setFormMode] = useState('add');
  const [selectedIdea, setSelectedIdea] = useState(null);

  const navigate = useNavigate();

  const fetchData = async (currentPage, pageLength) => {
    setIsLoading(true);
    try {
      const offset = (currentPage - 1) * pageLength;
      const response = await fetchContentTour(pageLength, offset);
      const data = response.results || [];
      setIdeas(data);
      setTotalCount(response.total_count || 0);
    } catch (error) {
      console.error('Error fetching ideas:', error);
      setIdeas([]);
      setTotalCount(0);
    } finally {
      setIsLoading(false);
    }
  };

  const refreshTable = async () => {
    await fetchData(currentPage, pageLength);
  };

  const handleInsert = async (data) => {
    try {
      const response = await insertContentTour(data);
      await refreshTable();
      setShowForm(false);
      return response;
    } catch (error) {
      console.error('Error inserting idea:', error);
      throw error;
    }
  };

  const handleUpdate = async (data) => {
    try {
      const response = await updateContentTour(data);
      await refreshTable();
      setShowForm(false);
      return response;
    } catch (error) {
      console.error('Error updating idea:', error);
      throw error;
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await deleteContentTour(id);
      await refreshTable();
      return response;
    } catch (error) {
      console.error('Error deleting idea:', error);
      throw error;
    }
  };

  const handlePageLengthChange = (e) => {
    setPageLength(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  const openForm = (mode, idea = null) => {
    setFormMode(mode);
    setSelectedIdea(idea);
    setShowForm(true);
  };

  const closeForm = () => {
    setShowForm(false);
    setSelectedIdea(null);
  };

  const handleSave = async (data) => {
    if (formMode === 'add') {
      await handleInsert(data);
    } else {
      await handleUpdate(data);
    }
  };

  // ฟังก์ชันสำหรับจัดการการกดปุ่มย้อนกลับ
  const handleHeaderBack = () => {
    if (showForm) {
      // เรียกการทำงานเหมือน onCancel ใน TourForm
      closeForm(); // ปิดฟอร์มเพื่อกลับไป Tourview
    } else {
      // อยู่ใน Tourview ให้ย้อนกลับไปหน้าก่อนหน้า
      navigate(-1);
    }
  };

  useEffect(() => {
    fetchData(currentPage, pageLength);
    // eslint-disable-next-line
  }, [currentPage, pageLength]);

  return (
    <div className="dashboard">
      <Sidebar />
      <div className="dashboard-main">
        <Header
          onBack={handleHeaderBack} // ส่งฟังก์ชัน handleHeaderBack ไปยัง Header.js
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          placeholderText="Search ideas..."
          refreshData={refreshTable}
        />
        <div className="p-datatable-details">
          <div className="member-table-container">
            {isLoading ? (
              <div className="text-center my-4">
                <ProgressSpinner
                  style={{ width: '50px', height: '50px' }}
                  strokeWidth="8"
                  fill="transparent"
                  animationDuration=".5s"
                />
              </div>
            ) : showForm ? (
              <TourForm
                ideaData={selectedIdea}
                mode={formMode}
                onCancel={closeForm}
                onSave={handleSave}
              />
            ) : (
              <Tourview
                headers={ideas}
                setHeaders={setIdeas}
                totalCount={totalCount}
                searchQuery={searchQuery}
                pageLength={pageLength}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                handlePageLengthChange={handlePageLengthChange}
                refreshData={refreshTable}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreBlog;